export function newPackageObject() {
  this.packageTitle = null
  this.packageDescription = null
  this.packageTitleImageURL = null
  this.packagePriority = null
}